var style = document.createElement('style');
var color_spinner = '#2c2c2b';
style.innerHTML = `
.editweb-spin-parent {
    position: relative;
}
.editweb-spin-container {
    position: absolute;
    background-color: rgba(255,255,255,0.8);
    width: 100%;
    display: flex;
    align-content: center;
    align-items: center;
    height: 100%;
    top: 0;
    left: 0;
    justify-content: center;
    z-index: 8;
}

.sk-chase {
  width: 40px;
  height: 40px;
  position: relative;
  animation: sk-chase 2.5s infinite linear both;
}

.sk-chase-dot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: sk-chase-dot 2.0s infinite ease-in-out both;
}

.sk-chase-dot:before {
  content: '';
  display: block;
  width: 25%;
  height: 25%;
  background-color: ` + color_spinner + `;
  border-radius: 100%;
  animation: sk-chase-dot-before 2.0s infinite ease-in-out both;
}

.sk-chase-dot:nth-child(1) { animation-delay: -1.1s; }
.sk-chase-dot:nth-child(2) { animation-delay: -1.0s; }
.sk-chase-dot:nth-child(3) { animation-delay: -0.9s; }
.sk-chase-dot:nth-child(4) { animation-delay: -0.8s; }
.sk-chase-dot:nth-child(5) { animation-delay: -0.7s; }
.sk-chase-dot:nth-child(6) { animation-delay: -0.6s; }
.sk-chase-dot:nth-child(1):before { animation-delay: -1.1s; }
.sk-chase-dot:nth-child(2):before { animation-delay: -1.0s; }
.sk-chase-dot:nth-child(3):before { animation-delay: -0.9s; }
.sk-chase-dot:nth-child(4):before { animation-delay: -0.8s; }
.sk-chase-dot:nth-child(5):before { animation-delay: -0.7s; }
.sk-chase-dot:nth-child(6):before { animation-delay: -0.6s; }

@keyframes sk-chase {
  100% { transform: rotate(360deg); }
}

@keyframes sk-chase-dot {
  80%, 100% { transform: rotate(360deg); }
}

@keyframes sk-chase-dot-before {
  50% {
    transform: scale(0.4);
  } 100%, 0% {
    transform: scale(1.0);
  }
}

.spinner {
  width: 40px;
  height: 40px;

  position: relative;
  margin: 100px auto;
}

.double-bounce1, .double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: ` + color_spinner + `;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}


.edit-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.edit-ripple div {
  position: absolute;
  border: 4px solid ` + color_spinner + `;
  opacity: 1;
  border-radius: 50%;
  animation: edit-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.edit-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes edit-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.edit-btn--loading{
    pointer-events:none;
    color:transparent !important;
}
.edit-btn--loading *{
    color:transparent !important;
    visibility:hidden !important;
}

.edit-btn--loading::after {
  content: "";
  position: absolute;
  width: 23px;
  height: 23px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 4px solid #eee;
  border-top-color: ` + color_spinner + `;
  border-radius: 50%;
  animation: edit-btn-loading-spinner 1s ease infinite;
}

.wrap_loader{
position:relative;
display:flex
}

.wrap_loader input{
    height:100%;
}

.wrap_loader::after {
  content: "";
  position: absolute;
  width: 23px;
  height: 23px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 4px solid #eee;
  border-top-color: ` + color_spinner + `;
  border-radius: 50%;
  animation: edit-btn-loading-spinner 1s ease infinite;
}

@keyframes edit-btn-loading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}
  `;
document.head.appendChild(style);

window.Spin = new function () {
    var self = this;
    self.default_template = 'chase';
    self.class_elem_parent = 'editweb-spin-parent';
    self.class_spin_container = 'editweb-spin-container';
    self.class_loader_btn = 'edit-btn--loading';

    self.$elem = null;

    self.$elem_btn = null;

    self.getIstance = function () {
        return $.extend(true, Object.create(Object.getPrototypeOf(self)), self);
        //return Object.assign(Object.create(Object.getPrototypeOf(Spin)), Spin)
    }

    self.template = function (type) {
        type = (typeof type !== 'undefined') ? type : self.default_template;
        var html = ''
        switch (type) {
            case 'chase':
                html = `
                <div class="sk-chase">
                  <div class="sk-chase-dot"></div>
                  <div class="sk-chase-dot"></div>
                  <div class="sk-chase-dot"></div>
                  <div class="sk-chase-dot"></div>
                  <div class="sk-chase-dot"></div>
                  <div class="sk-chase-dot"></div>
                </div>
                `;
                break;
            case 'bounce':
                html = `
                <div class="spinner">
                  <div class="double-bounce1"></div>
                  <div class="double-bounce2"></div>
                </div>
                `;
                break;
            case 'ripple':
                html = `
                    <div class="edit-ripple">
                        <div></div>
                        <div></div>
                    </div>
                `;
                break;
        }
        return html
    }

    self.add = function ($elem) {
        var template = self.template();
        self.remove($elem);
        $elem.append("<div class='" + self.class_spin_container + "'>" + template + "</div>");
        $elem.addClass(self.class_elem_parent);
    }

    self.remove = function ($elem) {
        $elem.find('.' + self.class_spin_container).remove()
        $elem.removeClass(self.class_elem_parent);
    }

    self.loader = function ($elem, template) {
        template = (typeof template !== 'undefined' && template !== null && template != '') ? template : 'ripple';
        self.$elem = $elem;
        var html = self.template(template);
        self.remove(self.$elem);
        self.$elem.append("<div class='" + self.class_spin_container + "'>" + html + "</div>");
        self.$elem.addClass(self.class_elem_parent);
    }

    self.removeLoader = function () {
        self.remove(self.$elem);
        self.$elem = null;
    }

    self.loaderBtn = function ($elem, classname) {
        classname = (typeof classname !== 'undefined' && classname !== null && classname != '') ? classname : self.class_loader_btn;
        self.$elem_btn = $elem;
        $elem.addClass(classname);
        if($elem.is('input')){
            $elem.wrap('<span class="wrap_loader" style="height:'+$elem.outerHeight()+'px"></span>')
        }
    }
    self.removeLoaderBtn = function ($elem, classname) {
        $elem = (typeof $elem !== 'undefined') ? $elem : self.$elem_btn;
        classname = (typeof classname !== 'undefined') ? classname : self.class_loader_btn;
        $elem.removeClass(classname);
        if($elem.is('input')){
            $elem.unwrap()
        }
    }
}
